module.exports = __webpack_public_path__ + "img/example-contest-inscription-qr-code.71046562.webp";